import type { SVGProps } from "react";
import * as React from "react";

const SvgGitCommit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.05 11a1 1 0 1 0 0 2zM7 13a1 1 0 1 0 0-2zm10.01-2a1 1 0 1 0 0 2zm5.95 2a1 1 0 1 0 0-2zM15 12a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V7a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zM1.05 13H7v-2H1.05zm15.96 0h5.95v-2h-5.95z"
    />
  </svg>
);
export default SvgGitCommit;
